import { ComboboxData, Group } from "@mantine/core"
import { ActionIcon, InlineSelectInput } from "@tfg/ui"
import { useEffect, useState } from "react"

import { FindMappingByTypeResponseDtoType } from "~/gen/api/types"
import { typeComponent } from "~/pages/Brand/OrganizationSettings/Mapping/components/MappingTable"
import { useDeleteMappingElementMutation } from "~/pages/Brand/OrganizationSettings/Mapping/hooks/useDeleteMappingElementMutation"
import { useUpdateMappingElementMutation } from "~/pages/Brand/OrganizationSettings/Mapping/hooks/useUpdateMappingElementMutation"
import { TypeKeys } from "~/pages/Brand/OrganizationSettings/Mapping/types"
import { showAxiosError } from "~/utils/showAxiosError"

export type SelectProps = {
  typesList: TypeKeys[]
  mappingType: typeComponent
  typeName: FindMappingByTypeResponseDtoType
}

export function filterDeletedAtSelectOptions(
  list: TypeKeys[] | undefined,
  id: number
): ComboboxData {
  if (!list) return []
  return list
    .filter((item) => !item.deletedAt || item.id === id)
    .map((list) => ({
      value: list.id.toString(),
      label: list.key,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
}

export function MappingSelect({
  typesList,
  mappingType,
  typeName,
}: SelectProps) {
  const { mutate: updateMappingType } = useUpdateMappingElementMutation({
    onError: (error) => {
      showAxiosError({
        error: error as Error,
        showNotification: true,
      })
    },
  })
  const { mutate: deleteMappingType } = useDeleteMappingElementMutation()

  const [options, setOptions] = useState<ComboboxData>([])
  const [value, setValue] = useState<string | null>(
    mappingType.type.typeId ? mappingType.type.typeId.toString() : null
  )

  useEffect(
    () => setOptions(filterDeletedAtSelectOptions(typesList, Number(value))),
    [typesList, value]
  )

  return (
    <Group justify="space-between" wrap="nowrap" w="100%">
      <InlineSelectInput
        options={options}
        value={value}
        onChange={(value: string | null) => {
          setValue(value)
          if (value) {
            updateMappingType({
              type: mappingType.type.type,
              typeId: Number(value),
              alias: mappingType.type.alias,
            })
          }
        }}
        selectProps={{
          searchable: true,
        }}
        label={mappingType.type.alias}
        size="sm"
        cta={
          <ActionIcon
            type="delete"
            onClick={() =>
              deleteMappingType({
                alias: mappingType.type.alias,
                type: typeName,
              })
            }
          />
        }
      />
    </Group>
  )
}
